// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-import-export__tabs {
  display: flex;
  gap: 0;
  margin-bottom: var(--dp-spacing-md);
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
}

.dp-import-export__tab {
  flex: 1;
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  border: none;
  background: none;
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-semibold);
  cursor: pointer;
  color: var(--dp-color-text-secondary);
  border-bottom: 2px solid transparent;
}

.dp-import-export__tab--active {
  color: var(--dp-color-primary);
  border-bottom-color: var(--dp-color-primary);
}

.dp-import-export__section {
  margin-bottom: var(--dp-spacing-md);
}

.dp-import-export__section-title {
  margin: 0 0 var(--dp-spacing-xs);
  font-size: var(--dp-font-size-md);
  color: var(--dp-color-text);
}

.dp-import-export__desc {
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
  margin: 0 0 var(--dp-spacing-md);
  line-height: 1.4;
}

/* Inline secondary text shown inside a label (e.g. "Loading versions…" or
 * "Template not found"). Keeps the form layout stable while the version
 * dropdown is unavailable — the slot doesn't collapse, so the button
 * doesn't jump up and down as the user types. */
.dp-import-export__hint {
  display: inline-block;
  font-size: 11px;
  color: #64748b;
  font-style: italic;
  margin-top: 4px;
}
.dp-import-export__hint--error {
  color: #b91c1c;
  font-style: normal;
}

.dp-import-export__btn {
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  border: none;
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-semibold);
  cursor: pointer;
}

.dp-import-export__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dp-import-export__btn--primary {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  width: 100%;
}

.dp-import-export__btn--danger {
  background: #c62828;
  color: #fff;
}

.dp-import-export__btn--cancel {
  background: var(--dp-color-surface, #f8f9fa);
  color: var(--dp-color-text);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
}

.dp-import-export__divider {
  border: none;
  border-top: var(--dp-border-width-thin) solid var(--dp-color-border);
  margin: var(--dp-spacing-md) 0;
}

.dp-import-export__file-label {
  display: inline-block;
  cursor: pointer;
}

.dp-import-export__file-btn {
  display: inline-block;
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  background: var(--dp-color-surface, #f8f9fa);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text);
}

.dp-import-export__file-input {
  display: none;
}

.dp-import-export__confirm {
  margin-top: var(--dp-spacing-md);
  padding: var(--dp-spacing-md);
  background: #fff8e1;
  border: var(--dp-border-width-thin) solid #ffe082;
  border-radius: var(--dp-border-radius-sm);
}

.dp-import-export__confirm h4 {
  margin: 0 0 var(--dp-spacing-xs);
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-text);
}

.dp-import-export__confirm p {
  margin: 0 0 var(--dp-spacing-md);
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
}

.dp-import-export__confirm-actions {
  display: flex;
  gap: var(--dp-spacing-sm);
}

.dp-import-export__message {
  margin-top: var(--dp-spacing-md);
  padding: var(--dp-spacing-sm);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
}

.dp-import-export__message--success {
  background: #e8f5e9;
  color: #2e7d32;
}

.dp-import-export__message--error {
  background: #fde8e8;
  color: #c62828;
}

/* Package export */
.dp-import-export__package-export {
  display: flex;
  flex-direction: column;
  gap: var(--dp-spacing-sm);
}

.dp-import-export__text-input {
  display: block;
  width: 100%;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  margin-top: var(--dp-spacing-xs);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  box-sizing: border-box;
}

/* Validation results */
.dp-import-export__validating {
  margin-top: var(--dp-spacing-md);
  padding: var(--dp-spacing-sm);
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
  font-style: italic;
}

.dp-import-export__validation {
  margin-top: var(--dp-spacing-md);
  padding: var(--dp-spacing-md);
  background: var(--dp-color-surface, #f8f9fa);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
}

.dp-import-export__validation h4 {
  margin: 0 0 var(--dp-spacing-sm);
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-text);
}

.dp-import-export__template-list {
  display: flex;
  flex-direction: column;
  gap: var(--dp-spacing-sm);
  margin-bottom: var(--dp-spacing-md);
}

.dp-import-export__template-item {
  padding: var(--dp-spacing-sm);
  background: #fff;
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
}

.dp-import-export__template-name {
  display: flex;
  align-items: center;
  gap: var(--dp-spacing-xs);
  margin-bottom: 2px;
  font-size: var(--dp-font-size-sm);
}

.dp-import-export__template-meta {
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
  margin-bottom: var(--dp-spacing-xs);
}

.dp-import-export__conflict-badge {
  display: inline-block;
  padding: 1px 6px;
  background: #fff3e0;
  color: #e65100;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
}

.dp-import-export__conflict-select {
  width: 100%;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  margin-top: var(--dp-spacing-xs);
}

.dp-import-export__missing-fields {
  margin-bottom: var(--dp-spacing-md);
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
}

.dp-import-export__missing-fields ul {
  margin: var(--dp-spacing-xs) 0 0 var(--dp-spacing-md);
  padding: 0;
}

.dp-import-export__missing-fields li {
  margin-bottom: 2px;
}

.dp-import-export__import-result {
  margin-top: var(--dp-spacing-md);
  padding: var(--dp-spacing-md);
  background: #e8f5e9;
  border: var(--dp-border-width-thin) solid #a5d6a7;
  border-radius: var(--dp-border-radius-sm);
}

.dp-import-export__import-result h4 {
  margin: 0 0 var(--dp-spacing-xs);
  font-size: var(--dp-font-size-sm);
}

.dp-import-export__error-list {
  margin: var(--dp-spacing-xs) 0 0 var(--dp-spacing-md);
  padding: 0;
  font-size: var(--dp-font-size-xs);
  color: #c62828;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/ImportExport.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,MAAM;EACN,mCAAmC;EACnC,uEAAuE;AACzE;;AAEA;EACE,OAAO;EACP,kDAAkD;EAClD,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;;gDAGgD;AAChD;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,YAAY;EACZ,yCAAyC;EACzC,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,gEAAgE;AAClE;;AAEA;EACE,YAAY;EACZ,oEAAoE;EACpE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,4CAA4C;EAC5C,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;EACnB,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kDAAkD;EAClD,gCAAgC;EAChC,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,4CAA4C;EAC5C,gEAAgE;EAChE,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gEAAgE;EAChE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;EACnB,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,qDAAqD;EACrD,UAAU;EACV,iCAAiC;EACjC,cAAc;AAChB","sourcesContent":[".dp-import-export__tabs {\n  display: flex;\n  gap: 0;\n  margin-bottom: var(--dp-spacing-md);\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n}\n\n.dp-import-export__tab {\n  flex: 1;\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  border: none;\n  background: none;\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-semibold);\n  cursor: pointer;\n  color: var(--dp-color-text-secondary);\n  border-bottom: 2px solid transparent;\n}\n\n.dp-import-export__tab--active {\n  color: var(--dp-color-primary);\n  border-bottom-color: var(--dp-color-primary);\n}\n\n.dp-import-export__section {\n  margin-bottom: var(--dp-spacing-md);\n}\n\n.dp-import-export__section-title {\n  margin: 0 0 var(--dp-spacing-xs);\n  font-size: var(--dp-font-size-md);\n  color: var(--dp-color-text);\n}\n\n.dp-import-export__desc {\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n  margin: 0 0 var(--dp-spacing-md);\n  line-height: 1.4;\n}\n\n/* Inline secondary text shown inside a label (e.g. \"Loading versions…\" or\n * \"Template not found\"). Keeps the form layout stable while the version\n * dropdown is unavailable — the slot doesn't collapse, so the button\n * doesn't jump up and down as the user types. */\n.dp-import-export__hint {\n  display: inline-block;\n  font-size: 11px;\n  color: #64748b;\n  font-style: italic;\n  margin-top: 4px;\n}\n.dp-import-export__hint--error {\n  color: #b91c1c;\n  font-style: normal;\n}\n\n.dp-import-export__btn {\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  border: none;\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-semibold);\n  cursor: pointer;\n}\n\n.dp-import-export__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dp-import-export__btn--primary {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  width: 100%;\n}\n\n.dp-import-export__btn--danger {\n  background: #c62828;\n  color: #fff;\n}\n\n.dp-import-export__btn--cancel {\n  background: var(--dp-color-surface, #f8f9fa);\n  color: var(--dp-color-text);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n}\n\n.dp-import-export__divider {\n  border: none;\n  border-top: var(--dp-border-width-thin) solid var(--dp-color-border);\n  margin: var(--dp-spacing-md) 0;\n}\n\n.dp-import-export__file-label {\n  display: inline-block;\n  cursor: pointer;\n}\n\n.dp-import-export__file-btn {\n  display: inline-block;\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  background: var(--dp-color-surface, #f8f9fa);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text);\n}\n\n.dp-import-export__file-input {\n  display: none;\n}\n\n.dp-import-export__confirm {\n  margin-top: var(--dp-spacing-md);\n  padding: var(--dp-spacing-md);\n  background: #fff8e1;\n  border: var(--dp-border-width-thin) solid #ffe082;\n  border-radius: var(--dp-border-radius-sm);\n}\n\n.dp-import-export__confirm h4 {\n  margin: 0 0 var(--dp-spacing-xs);\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-text);\n}\n\n.dp-import-export__confirm p {\n  margin: 0 0 var(--dp-spacing-md);\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n}\n\n.dp-import-export__confirm-actions {\n  display: flex;\n  gap: var(--dp-spacing-sm);\n}\n\n.dp-import-export__message {\n  margin-top: var(--dp-spacing-md);\n  padding: var(--dp-spacing-sm);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n}\n\n.dp-import-export__message--success {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.dp-import-export__message--error {\n  background: #fde8e8;\n  color: #c62828;\n}\n\n/* Package export */\n.dp-import-export__package-export {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dp-spacing-sm);\n}\n\n.dp-import-export__text-input {\n  display: block;\n  width: 100%;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  margin-top: var(--dp-spacing-xs);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  box-sizing: border-box;\n}\n\n/* Validation results */\n.dp-import-export__validating {\n  margin-top: var(--dp-spacing-md);\n  padding: var(--dp-spacing-sm);\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n  font-style: italic;\n}\n\n.dp-import-export__validation {\n  margin-top: var(--dp-spacing-md);\n  padding: var(--dp-spacing-md);\n  background: var(--dp-color-surface, #f8f9fa);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n}\n\n.dp-import-export__validation h4 {\n  margin: 0 0 var(--dp-spacing-sm);\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-text);\n}\n\n.dp-import-export__template-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dp-spacing-sm);\n  margin-bottom: var(--dp-spacing-md);\n}\n\n.dp-import-export__template-item {\n  padding: var(--dp-spacing-sm);\n  background: #fff;\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n}\n\n.dp-import-export__template-name {\n  display: flex;\n  align-items: center;\n  gap: var(--dp-spacing-xs);\n  margin-bottom: 2px;\n  font-size: var(--dp-font-size-sm);\n}\n\n.dp-import-export__template-meta {\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n  margin-bottom: var(--dp-spacing-xs);\n}\n\n.dp-import-export__conflict-badge {\n  display: inline-block;\n  padding: 1px 6px;\n  background: #fff3e0;\n  color: #e65100;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.dp-import-export__conflict-select {\n  width: 100%;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  margin-top: var(--dp-spacing-xs);\n}\n\n.dp-import-export__missing-fields {\n  margin-bottom: var(--dp-spacing-md);\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n}\n\n.dp-import-export__missing-fields ul {\n  margin: var(--dp-spacing-xs) 0 0 var(--dp-spacing-md);\n  padding: 0;\n}\n\n.dp-import-export__missing-fields li {\n  margin-bottom: 2px;\n}\n\n.dp-import-export__import-result {\n  margin-top: var(--dp-spacing-md);\n  padding: var(--dp-spacing-md);\n  background: #e8f5e9;\n  border: var(--dp-border-width-thin) solid #a5d6a7;\n  border-radius: var(--dp-border-radius-sm);\n}\n\n.dp-import-export__import-result h4 {\n  margin: 0 0 var(--dp-spacing-xs);\n  font-size: var(--dp-font-size-sm);\n}\n\n.dp-import-export__error-list {\n  margin: var(--dp-spacing-xs) 0 0 var(--dp-spacing-md);\n  padding: 0;\n  font-size: var(--dp-font-size-xs);\n  color: #c62828;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
